<script setup lang="ts">
import KLink from '@/components/KLink.vue';

import { type NavigationItem } from './KSidebarList.vue';

const props = withDefaults(
  defineProps<{
    item: NavigationItem;
    useProxy?: boolean;
    current: boolean;
    subItem?: boolean;
  }>(),
  { useProxy: true, subItem: false },
);
</script>

<template>
  <KLink
    :use-proxy="props.useProxy"
    :to="{ name: props.item.routeName }"
    :class="[
      'flex gap-x-3 rounded-md text-sm leading-6 focus-visible:outline-2 focus-visible:outline-blue-400',
      props.current
        ? 'bg-gray-50 font-bold text-gray-900 dark:bg-navy-900 dark:text-white'
        : 'text-gray-700 hover:bg-gray-50 dark:text-gray-400 dark:hover:bg-navy-900',
      props.subItem ? 'py-2 pl-9 pr-2' : 'p-2',
    ]"
  >
    <slot>
      {{ props.item.display }}
    </slot>
  </KLink>
</template>
